import { getAllCategoryIds } from './categories.js';
// Ключові слова: українські, російські та англійські. Скоринг — нижче.
// Id відповідають таксономії categories.ts: вертикаль «автозапчастини»
// (parts-*) + приховані загальні категорії. Точний розподіл по
// підкатегоріях запчастин — у parts-classifier.ts (classifyScoped).
const categoryKeywords = {
    // --- Автозапчастини (вертикаль сайту) ---
    'parts-cars': [
        'запчастини',
        'автозапчастини',
        'запчасть',
        'запчасти',
        'автозапчасть',
        'розбірка легков',
        'на легков',
        // частотні назви запчастин — щоб підказка не падала в приховані auto-*
        'колодки',
        'фільтр',
        'фильтр',
        'свічки',
        'свечи',
        'ремінь',
        'ремень',
        'генератор',
        'стартер',
        'амортизатор',
        'реле',
        'прокладка',
        'підшипник',
        'подшипник',
        'ступиця',
        'ступица',
        'гальмо',
        'суппорт',
        'радіатор',
        'радиатор',
        'бампер',
        'фара',
        'двигун',
        'двигатель',
        'коробка передач',
        'акпп',
        'мкпп',
        'кузов',
        'турбіна',
        'турбина',
        'акумулятор',
        'аккумулятор',
        'шрус',
        'кпп',
        'spare parts',
    ],
    'parts-trucks': [
        'вантажн',
        'грузов',
        'тягач',
        'причеп',
        'полуприцеп',
        'вантажівк',
        'трактор',
        'даф',
        'daf',
        'ман',
        'man',
        'сканія',
        'scania',
        'вольво вантаж',
        'reno вантаж',
    ],
    'parts-agri': [
        'сільгосптехнік',
        'сельхозтехник',
        'сільськогосподарськ',
        'комбайн',
        'тракторн',
        'мтз',
        'юниз',
        'john deere',
        'спецтехнік',
        'спецтехник',
        'екскаватор',
        'бульдозер',
        'погрузчик',
    ],
    'parts-moto': [
        'мотозапчастини',
        'мотозапчасти',
        'мотоцикл',
        'скутер',
        'мопед',
        'пітбайк',
        'кросов',
        'шолом',
        'helmet',
        'мото',
    ],
    'parts-wheels': [
        'шини',
        'покришки',
        'покрышки',
        'диски колісн',
        'резина',
        'зимова резина',
        'літня резина',
        'колеса',
        'шиповані',
        'литі диски',
        'r16',
        'r17',
        'r18',
        'tires',
        'tyres',
    ],
    'parts-accessories': [
        'автоаксесуари',
        'автоаксессуары',
        'автотовари',
        'автоприладдя',
        'чохол на сидіння',
        'дефлектори',
        'виделорожувач',
        'видеорегистратор',
        'парктронік',
        'парктроник',
        'тримач телефону',
        'ароматизатор',
        'автохімія',
        'автохимия',
        'мастило',
        'масло моторн',
    ],
    'parts-breakers': [
        'авторозбірка',
        'разборка',
        'розбірка',
        'на запчастини',
        'на разбор',
        'розбираю',
        'донор',
        'буксує',
    ],
    'parts-other': ['запчастини для іншої техніки', 'інші запчастини', 'прочие запчасти'],
    // --- Електроніка ---
    electronics: [
        'електроніка',
        'гаджет',
        'техніка',
        'цифровий',
        'электроника',
        'техника',
        'digital',
        'electronics',
        'gadget',
        'device',
    ],
    'electronics-phones': [
        'телефон',
        'смартфон',
        'айфон',
        'мобільний',
        'мобілка',
        'смарт-годинник',
        'iphone',
        'samsung',
        'xiaomi',
        'huawei',
        'honor',
        'poco',
        'oneplus',
        'galaxy',
        'redmi',
        'pixel',
        'phone',
        'smartphone',
    ],
    'electronics-laptops': [
        'ноутбук',
        'компʼютер',
        'системний блок',
        'моноблок',
        'процесор',
        'операційна памʼять',
        'відеокарта',
        'приставка', // «ігрова приставка» нижче важливіша, але компʼютерна периферія теж тут
        'клавіатура',
        'миша',
        'macbook',
        'lenovo',
        'asus',
        'acer',
        'hp',
        'dell',
        'msi',
        'ssd',
        'hdd',
        'компьютер',
        'пк',
        'laptop',
        'notebook',
        'computer',
        'pc',
    ],
    'electronics-tv': [
        'телевізор',
        'монітор',
        'саундбар',
        'домашній кінотеатр',
        'ресивер',
        'колонка',
        'аудіо',
        'посилювач',
        'проєктор',
        'телевизор',
        'монитор',
        'усилитель',
        'tv',
        'audio',
        'soundbar',
        'speaker',
        'projector',
    ],
    'electronics-photo': [
        'фотоапарат',
        'камера',
        'обʼєктив',
        'дзеркалка',
        'штатив',
        'дрон',
        'квадрокоптер',
        'екшн камера',
        'фотоаппарат',
        'объектив',
        'зеркалка',
        'canon',
        'nikon',
        'sony',
        'fujifilm',
        'gopro',
        'camera',
        'lens',
        'drone',
    ],
    'electronics-games': [
        'приставка',
        'ігрова приставка',
        'ігри',
        'геймпад',
        'джойстик',
        'ігрова миша',
        'vr окуляри',
        'гра',
        'консоль',
        'playstation',
        'xbox',
        'nintendo',
        'switch',
        'steam',
        'ігровий',
        'game',
        'gaming',
        'console',
        'controller',
    ],
    // --- Дім і сад ---
    home: ['дім', 'квартира', 'інтерʼєр', 'побутова', 'дом', 'home', 'house', 'apartment'],
    'home-furniture': [
        'меблі',
        'диван',
        'ліжко',
        'стіл',
        'стілець',
        'шафа',
        'комод',
        'тумбочка',
        'полиця',
        'крісло',
        'стелаж',
        'мебель',
        'кровать',
        'стол',
        'стул',
        'шкаф',
        'тумба',
        'кресло',
        'стеллаж',
        'furniture',
        'sofa',
        'bed',
        'table',
        'chair',
    ],
    'home-appliances': [
        'побутова техніка',
        'холодильник',
        'пральна машина',
        'праска',
        'пилосос',
        'мікрохвильовка',
        'духовка',
        'плита',
        'бойлер',
        'кухонний комбайн',
        'мультиварка',
        'блендер',
        'кавоварка',
        'тостер',
        'соковитискачка',
        'кондиціонер',
        'обігрівач',
        'стиральная',
        'пылесос',
        'микроволновка',
        'fridge',
        'washing machine',
        'vacuum',
        'microwave',
        'kettle',
    ],
    'home-dishes': [
        'посуд',
        'каструля',
        'сковорода',
        'тарілка',
        'чашка',
        'кружка',
        'склянка',
        'чайник',
        'сервіз',
        'набір столовий',
        'посуда',
        'кастрюля',
        'тарелка',
        'стакан',
        'ковш',
        'tableware',
    ],
    'home-tools': [
        'інструмент',
        'інструменти',
        'дриль',
        'шуруповерт',
        'перфоратор',
        'болгарка',
        'пила',
        'молоток',
        'відвертка',
        'пасатижі',
        'рулетка',
        'рівень',
        'сантехніка',
        'змішувач',
        'инструмент',
        'дрель',
        'отвертка',
        'гаечный',
        'шпатель',
        'труба',
        'кран',
        'смеситель',
        'унитаз',
        'раковина',
        'розетка',
        'вимикач',
        'выключатель',
        'провод',
        'кабель',
        'tools',
        'plumbing',
    ],
    'home-garden': [
        'дача',
        'сад',
        'город',
        'теплиця',
        'розсада',
        'насіння',
        'грунт',
        'добриво',
        'мотоблок',
        'газонокосарка',
        'лопата',
        'граблі',
        'сапка',
        'саджанці',
        'полив',
        'кімнатні рослини',
        'рассада',
        'семена',
        'газонокосилка',
        'саженец',
        'грядка',
        'garden',
        'seeds',
        'plants',
    ],
    'home-build': [
        'будматеріали',
        'цемент',
        'цегла',
        'гіпсокартон',
        'профіль',
        'утеплювач',
        'гідроізоляція',
        'ламінат',
        'лінолеум',
        'плитка',
        'фарба',
        'шпалери',
        'двері',
        'вікно',
        'металочерепиця',
        'профнастил',
        'дошки',
        'кирпич',
        'гипсокартон',
        'утеплитель',
        'ламинат',
        'линолеум',
        'краска',
        'обои',
        'cement',
        'brick',
        'paint',
    ],
    // --- Одяг і взуття ---
    clothing: [
        'одяг',
        'взуття',
        'куртка',
        'розмір',
        'одежда',
        'обувь',
        'ношеный',
        'новый с биркой',
        'clothing',
        'shoes',
        'jacket',
        'dress',
        'shirt',
    ],
    'clothing-women': [
        'жіночий',
        'жіноча',
        'сукня',
        'спідниця',
        'блузка',
        'туфлі',
        'чоботи',
        'джинси жіночі',
        'кофта',
        'кардиган',
        'женская',
        'женский',
        'платье',
        'юбка',
        'сапоги',
        'пальто',
    ],
    'clothing-men': [
        'чоловічий',
        'чоловіча',
        'піджак',
        'сорочка',
        'костюм',
        'світшот',
        'черевики',
        'мужская',
        'мужской',
        'пиджак',
        'рубашка',
        'джинсы мужские',
        'ботинки мужские',
        'кожаная куртка',
    ],
    'clothing-kids': [
        'дитячий одяг',
        'дитяча',
        'дитячий',
        'для дітей',
        'підгузки',
        'детская',
        'детский',
        'подгузники',
        'школьная форма',
    ],
    'clothing-accessories': [
        'сумка',
        'гаманець',
        'ремінь',
        'окуляри',
        'годинник',
        'шапка',
        'шарф',
        'рукавички',
        'прикраси',
        'намисто',
        'серьги',
        'очки',
        'часы',
        'handbag',
        'wallet',
        'watch',
        'purse',
        'belt',
    ],
    // --- Дитячі товари ---
    kids: ['дитячі товари', 'дитячий', 'для дитини', 'малюк', 'детские товары', 'детям', 'малыш', 'kids'],
    'kids-toys': [
        'іграшка',
        'іграшки',
        'лялька',
        'машинка',
        'конструктор',
        'пазл',
        'розвиваючий',
        'горка',
        'гойдалка',
        'батут',
        'игрушка',
        'кукла',
        'lego',
        'погремушка',
        'toy',
        'toys',
    ],
    'kids-strollers': [
        'коляска',
        'автокрісло',
        'коляски',
        'автокресло',
        'стільчик для годування',
        'слінг',
        'кроватка',
        'stroller',
        'car seat',
    ],
    'kids-furniture': ['дитячі меблі', 'ліжечко', 'манеж', 'пеленальний', 'детская мебель', 'детская кроватка'],
    'kids-school': [
        'шкільний рюкзак',
        'портфель',
        'ранець',
        'зошит',
        'пенал',
        'школьный рюкзак',
        'тетрадь',
        'school',
        'школяру',
    ],
    // --- Авто і транспорт ---
    auto: [
        'авто',
        'машина',
        'транспорт',
        'мотоцикл',
        'скутер',
        'автомобіль',
        'автомобиль',
        'двигун',
        'кузов',
        'акпп',
        'мкпп',
        'коробка передач',
        'car',
        'auto',
        'vehicle',
        'motorcycle',
        'scooter',
    ],
    'auto-cars': [
        'легкове авто',
        'продам авто',
        'bmw',
        'toyota',
        'honda',
        'ford',
        'mercedes',
        'audi',
        'nissan',
        'vw',
        'volkswagen',
        'hyundai',
        'kia',
        'mazda',
        'subaru',
        'skoda',
        'renault',
        'peugeot',
    ],
    'auto-moto': [
        'велосипед',
        'байк',
        'гірський велосипед',
        'шосейний',
        'велозапчасти',
        'педалі',
        'рама',
        'мопед',
        'bike',
        'bicycle',
        'cycling',
    ],
    'auto-parts': [
        'запчастини',
        'автозапчастини',
        'колодки',
        'фільтр',
        'свічки',
        'ремінь',
        'генератор',
        'стартер',
        'амортизатор',
        'реле',
        'прокладка',
        'підшипник',
        'ступиця',
        'гальмо',
        'суппорт',
        'радіатор',
        'запчасти',
        'свечи',
        'тормозной',
        'ступица',
        'автодержатель',
        'чехол на сидіння',
        'дефлектори',
        'спойлер',
        'парктронік',
        'відеореєстратор',
        'parts',
        'spare',
        'accessories',
    ],
    'auto-tires': [
        'шини',
        'покришки',
        'диски',
        'резина',
        'зимова резина',
        'літня резина',
        'колеса',
        'шиповані',
        'литі диски',
        'покрышки',
        'tires',
        'tyres',
        'wheels',
        'winter tires',
    ],
    // --- Хобі і спорт ---
    sport: ['спорт', 'фітнес', 'тренування', 'спортивний', 'хобі', 'sport', 'fitness', 'gym', 'workout', 'hobby'],
    'sport-gear': [
        'інвентар',
        'гантелі',
        'штанга',
        'килимок для йоги',
        'скакалка',
        'мʼяч',
        'мяч',
        'ракетка',
        'шолом',
        'боксерські рукавички',
        'експандер',
        'тренажер',
        'бігова доріжка',
        'велотренажер',
        'турнік',
        'бруси',
        'лавка',
        'намет',
        'спальник',
        'туризм',
        'туристичний',
        'інвентарь',
        'гантели',
        'беговая дорожка',
        'эллипс',
        'турник',
        'скамья',
        'treadmill',
    ],
    'sport-books': [
        'книга',
        'книги',
        'підручник',
        'посібник',
        'роман',
        'повість',
        'казки',
        'енциклопедія',
        'словник',
        'атлас',
        'задачник',
        'хрестоматія',
        'дитяча книга',
        'учебник',
        'пособие',
        'энциклопедия',
        'словарь',
        'book',
        'textbook',
        'novel',
        'encyclopedia',
        'dictionary',
        'harry potter',
    ],
    'sport-music': [
        'музика',
        'гітара',
        'піаніно',
        'синтезатор',
        'барабан',
        'скрипка',
        'укулеле',
        'акордеон',
        'флейта',
        'підсилювач',
        'мікрофон',
        'вініл',
        'пластинка',
        'програвач',
        'гитара',
        'пианино',
        'баян',
        'усилитель',
        'колонка',
        'винил',
        'грампластинка',
        'проигрыватель',
        'вертушка',
        'guitar',
        'piano',
        'drums',
        'instrument',
        'vinyl',
        'record',
    ],
    'sport-collections': [
        'колекція',
        'антикваріат',
        'картина',
        'живопис',
        'скульптура',
        'ікона',
        'монета',
        'монети',
        'марка',
        'значок',
        'вінтаж',
        'ретро',
        'нумізматика',
        'мистецтво',
        'искусство',
        'живопись',
        'коллекция',
        'антиквариат',
        'икона',
        'art',
        'painting',
        'collection',
        'vintage',
        'antique',
        'coin',
        'stamp',
    ],
    // --- Тварини ---
    animals: [
        'тварини',
        'тварина',
        'пес',
        'собака',
        'кіт',
        'кішка',
        'птах',
        'рибки',
        'акваріум',
        'животные',
        'питомец',
        'pet',
        'dog',
        'cat',
        'animal',
    ],
    'animals-supplies': [
        'корм',
        'лакомство',
        'вітаміни',
        'нашийник',
        'повідець',
        'лежанка',
        'переноска',
        'дряпка',
        'лоток',
        'миска',
        'шлейка',
        'намордник',
        'ошейник',
        'поводок',
        'когтеточка',
        'витамины для',
        'pet food',
    ],
    'animals-adopt': [
        'в добрі руки',
        'добрі руки',
        'пристройка',
        'прилаштую',
        'цуценя',
        'котеня',
        'котенята',
        'цуценята',
        'вязка',
        'в\'язка',
    ],
    // --- Краса і здоровʼя ---
    beauty: [
        'краса',
        'здоровʼя',
        'косметика',
        'крем',
        'шампунь',
        'парфуми',
        'духи',
        'помада',
        'туш',
        'макіяж',
        'фен',
        'випрямляч',
        'епілятор',
        'догляд',
        'красота',
        'здоровье',
        'парфюм',
        'выпрямитель',
        'эпилятор',
        'beauty',
        'cosmetics',
        'perfume',
        'makeup',
    ],
    // --- Послуги ---
    services: ['послуги', 'послуга', 'сервіс', 'пропоную послуги', 'майстер', 'спеціаліст', 'услуги', 'service', 'мастер'],
    'services-construction': [
        'ремонт квартир',
        'будівництво',
        'оздоблення',
        'ремонт під ключ',
        'дизайн інтерʼєру',
        'плиточник',
        'штукатур',
        'маляр',
        'електрик',
        'сантехнік',
        'ремонт ванної',
        'ремонт кухні',
        'строительство',
        'отделка',
        'дизайн интерьера',
        'стяжка',
        'электрик',
        'сантехник',
        'construction',
        'renovation',
    ],
    'services-repair': [
        'ремонт техніки',
        'ремонт телефонів',
        'ремонт ноутбуків',
        'сервісний центр',
        'ремонт ноутбука',
        'ремонт телевізора',
        'заміна екрану',
        'заміна батареї',
        'ремонт пральної',
        'ремонт холодильника',
        'ремонт техники',
        'сервисный центр',
        'замена экрана',
        'замена батареи',
        'repair',
        'service center',
    ],
    'services-auto-repair': [
        'автосервіс',
        'сто',
        'шиномонтаж',
        'автомеханік',
        'діагностика авто',
        'розвал збіжність',
        'заміна масла',
        'автоелектрик',
        'кузовний ремонт',
        'фарбування авто',
        'полірування авто',
        'ремонт авто',
        'автосервис',
        'автомеханик',
        'развал схождение',
        'автоэлектрик',
        'кузовной ремонт',
        'покраска авто',
        'полировка авто',
        'car repair',
        'auto service',
    ],
    'services-transport': [
        'перевезення',
        'доставка',
        'вантажоперевезення',
        'переїзд',
        'вантажники',
        'вантажне таксі',
        'логістика',
        'евакуатор',
        'транспортні послуги',
        'перевезти',
        'перевозка',
        'грузоперевозка',
        'грузчики',
        'такси грузовое',
        'эвакуатор',
        'moving',
        'delivery',
        'transport',
    ],
    'services-cleaning': [
        'прибирання',
        'клінінг',
        'миття вікон',
        'хімчистка',
        'прибирання квартир',
        'миття килимів',
        'уборка',
        'клининг',
        'мойка окон',
        'мойка ковров',
        'dry cleaning',
        'cleaning',
    ],
    'services-education': [
        'репетитор',
        'навчання',
        'курси',
        'вчитель',
        'підготовка до',
        'заняття',
        'іноземна мова',
        'англійська мова',
        'математика',
        'обучение',
        'учитель',
        'иностранный язык',
        'английский язык',
        'tutor',
        'education',
        'lessons',
    ],
    'services-beauty': [
        'стрижка',
        'перукар',
        'манікюр',
        'педикюр',
        'нарощування нігтів',
        'брови',
        'вії',
        'бровист',
        'лайшмейкер',
        'зачіска',
        'фарбування волосся',
        'косметолог',
        'масаж',
        'парикмахер',
        'маникюр',
        'наращивание ногтей',
        'прическа',
        'окрашивание волос',
        'lashes',
        'hairstylist',
    ],
    'services-it': [
        'програміст',
        'розробка',
        'сайт',
        'it послуги',
        'ремонт компʼютерів',
        'налаштування',
        'веб розробка',
        'мобільний застосунок',
        'техпідтримка',
        'программист',
        'разработка',
        'веб разработка',
        'мобильное приложение',
        'техподдержка',
        'developer',
        'web development',
        'IT',
    ],
    'services-photo': [
        'фотограф',
        'фотосесія',
        'відеозйомка',
        'відеограф',
        'весільний фотограф',
        'ведучий',
        'тамада',
        'діджей',
        'організація',
        'заходи',
        'свято',
        'весілля',
        'день народження',
        'корпоратив',
        'кейтеринг',
        'оренда',
        'фотосессия',
        'видеосъемка',
        'видеограф',
        'свадебный фотограф',
        'мероприятие',
        'ведущий',
        'dj',
        'аренда',
        'праздник',
        'свадьба',
        'photographer',
        'photo session',
        'video',
        'event',
        'party',
    ],
    'services-legal': [
        'юрист',
        'адвокат',
        'нотаріус',
        'нотаріальні',
        'юридична допомога',
        'правова допомога',
        'консультація юриста',
        'представництво в суді',
        'складання позову',
        'довіреність',
        'заповіт',
        'апостиль',
        'нотариус',
        'нотариальная',
        'заверение',
        'доверенность',
        'договор дарения',
        'завещание',
        'удостоверение',
        'юридическая помощь',
        'правовая помощь',
        'lawyer',
        'legal',
        'notary',
    ],
    // --- Особливі ---
    free: [
        'даром',
        'безкоштовно',
        'віддам',
        'безкоштовний',
        'не потрібен',
        'заберіть',
        'бесплатно',
        'отдам',
        'бесплатный',
        'не нужен',
        'заберите',
        'free',
        'give away',
        'donation',
    ],
    other: ['різне', 'інше', 'разное', 'прочее', 'misc'],
};
function normalize(text) {
    return text
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s]/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
export function classify(text) {
    const normalized = normalize(text);
    const words = normalized.split(' ');
    const scores = {};
    const allIds = getAllCategoryIds();
    for (const catId of allIds) {
        const keywords = categoryKeywords[catId] || [];
        let score = 0;
        for (const kw of keywords) {
            const kwNorm = normalize(kw);
            if (normalized.includes(kwNorm)) {
                score += kwNorm.split(' ').length * 3;
            }
            const kwWords = kwNorm.split(' ');
            for (const word of words) {
                if (word.length < 3)
                    continue;
                if (kwWords.some((kwWord) => kwWord === word)) {
                    score += 1;
                }
            }
        }
        if (score > 0) {
            scores[catId] = score;
        }
    }
    const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    if (sorted.length === 0) {
        return { categoryId: 'other', confidence: 0.1, alternatives: [] };
    }
    const maxScore = sorted[0][1];
    const total = sorted.reduce((s, [, v]) => s + v, 0);
    const confidence = Math.min((maxScore / total) * sorted.length, 1);
    return {
        categoryId: sorted[0][0],
        confidence: Math.round(confidence * 100) / 100,
        alternatives: sorted.slice(1, 4).map(([categoryId, s]) => ({
            categoryId,
            confidence: Math.round((s / total) * sorted.length * 100) / 100,
        })),
    };
}
//# sourceMappingURL=classifier.js.map